import React from 'react';

const EditIcon = () => {
	return (
		<svg
			width='40'
			height='40'
			viewBox='0 0 40 40'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className='ml-12'
			title='Visa'
		>
			<path
				d='M17.5653 25.8333H15L16.6013 14.1666H19.1667L17.5653 25.8333Z'
				fill='#0066B3'
			/>
			<path
				d='M12.4757 14.1666L9.50861 22.191L9.15972 20.4619L8.10986 15.2153C8.10986 15.2153 7.98503 14.1666 6.6343 14.1666H1.7243L1.66669 14.3633C2.81626 14.6426 3.91514 15.092 4.92508 15.696L7.62975 25.8333H10.8753L15.8334 14.1666H12.4757Z'
				fill='#0066B3'
			/>
			<path
				d='M35.5366 25.8333H38.3333L35.8933 14.1705H33.4469C33.1497 14.1483 32.8531 14.2213 32.6004 14.3791C32.3477 14.5368 32.1522 14.7709 32.0423 15.0473L27.5 25.8333H30.6658L31.2915 24.1017H35.1644L35.5366 25.8333ZM32.1862 21.7086L33.7848 17.3405L34.6857 21.7086H32.1862Z'
				fill='#0066B3'
			/>
			<path
				d='M27.8955 17.0724L28.3334 14.6585C27.4477 14.3554 26.5173 14.1894 25.5771 14.1666C24.0556 14.1666 20.4425 14.8033 20.4425 17.8992C20.4425 20.8141 24.6824 20.8503 24.6824 22.3801C24.6824 23.91 20.8772 23.6384 19.6234 22.6819L19.1667 25.1954C20.2634 25.6346 21.4432 25.8514 22.6317 25.8321C24.7234 25.8321 27.8797 24.7941 27.8797 21.9728C27.8766 19.0398 23.5988 18.7652 23.5988 17.4919C23.5988 16.2185 26.5851 16.3784 27.8955 17.0724Z'
				fill='#0066B3'
			/>
			<path
				d='M9.16669 20.8333L8.11585 15.2772C8.11585 15.2772 7.99091 14.1666 6.63892 14.1666H1.72435L1.66669 14.3749C3.35833 14.8198 4.93655 15.6373 6.29291 16.7712C7.58207 17.8393 8.57368 19.241 9.16669 20.8333Z'
				fill='#FAA634'
			/>
		</svg>
	);
};

export default EditIcon;
